function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { createGlobalStyle } from 'styled-components';

var FocusOutlines = /*#__PURE__*/function (_Component) {
  _inherits(FocusOutlines, _Component);

  function FocusOutlines() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FocusOutlines);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FocusOutlines)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      disableFocusOutlines: false
    });

    _defineProperty(_assertThisInitialized(_this), "disableFocusOutlines", function () {
      // Mousedown will disable focus outlines
      if (_this.state.disableFocusOutlines === false) {
        _this.setState({
          disableFocusOutlines: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "enableFocusOutlines", function (e) {
      // Pressing tab will enable focus outlines
      if (_this.state.disableFocusOutlines === true && e.which === 9) {
        _this.setState({
          disableFocusOutlines: false
        });
      }
    });

    return _this;
  }

  _createClass(FocusOutlines, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.enableFocusOutlines);
      window.addEventListener('mousedown', this.disableFocusOutlines);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.enableFocusOutlines);
      window.removeEventListener('mousedown', this.disableFocusOutlines);
    }
  }, {
    key: "render",
    value: function render() {
      var disableFocusOutlines = this.state.disableFocusOutlines;
      return disableFocusOutlines ? React.createElement(DisableFocusOutlines, null) : null;
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return FocusOutlines;
}(Component);

var DisableFocusOutlines = createGlobalStyle([":focus{outline:none;}"]);
var _default = FocusOutlines;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FocusOutlines, "FocusOutlines", "/home/vsts/work/1/s/src/components/styles/FocusOutlines.js");
  reactHotLoader.register(DisableFocusOutlines, "DisableFocusOutlines", "/home/vsts/work/1/s/src/components/styles/FocusOutlines.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/styles/FocusOutlines.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();